import { AuditEntry } from "@/services/LBSubscriptionService";
import { LBSubscriptionAuditLog } from "../../lb-subscription/LBSubscriptionAuditLog";

interface AuditLogTabProps {
    auditLog: AuditEntry[];
}

export const AuditLogTab: React.FC<AuditLogTabProps> = ({ auditLog }) => {
    return (
        <div>
            <LBSubscriptionAuditLog auditLog={auditLog} />
        </div>
    );
};
